
import {
  useState
} from "react";

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate
} from "react-router-dom";

import Login from "./Components/Login/Login";
import Register from "./Components/Register/Register";
import Dashboard from "./Components/Dashboard/Dashboard";

import "./App.css";


// =====================================================
// APP ROUTES
// =====================================================

function AppRoutes() {

  const navigate =
    useNavigate();


  // ===================================================
  // AUTH STATE
  // ===================================================

  /*
    IMPORTANT:

    Do NOT check authentication when the application
    starts.

    Application always starts at LOGIN.

    Authentication becomes true only after successful
    login.
  */

  const [authenticated, setAuthenticated] =
    useState(false);


  // ===================================================
  // LOGIN SUCCESS
  // ===================================================

  const handleLoginSuccess =
    () => {

      console.log(
        "================================"
      );

      console.log(
        "LOGIN SUCCESS"
      );

      console.log(
        "Authentication state = TRUE"
      );

      console.log(
        "================================"
      );


      setAuthenticated(true);


      navigate(
        "/dashboard",
        {
          replace: true
        }
      );

    };


  // ===================================================
  // LOGOUT
  // ===================================================

  const handleLogout =
    () => {

      console.log(
        "================================"
      );

      console.log(
        "APP LOGOUT"
      );

      console.log(
        "Authentication state = FALSE"
      );

      console.log(
        "================================"
      );


      setAuthenticated(false);


      navigate(
        "/login",
        {
          replace: true
        }
      );

    };


  // ===================================================
  // ROUTES
  // ===================================================

  return (

    <Routes>


      {/* ============================================= */}
      {/* LOGIN */}
      {/* ============================================= */}

      <Route
        path="/login"
        element={
          authenticated
            ? (
                <Navigate
                  to="/dashboard"
                  replace
                />
              )
            : (
                <Login
                  onLoginSuccess={
                    handleLoginSuccess
                  }
                />
              )
        }
      />


      {/* ============================================= */}
      {/* REGISTER */}
      {/* ============================================= */}

      <Route
        path="/register"
        element={
          authenticated
            ? (
                <Navigate
                  to="/dashboard"
                  replace
                />
              )
            : (
                <Register
                  onRegisterSuccess={
                    handleLoginSuccess
                  }
                />
              )
        }
      />


      {/* ============================================= */}
      {/* DASHBOARD */}
      {/* ============================================= */}

      <Route
        path="/dashboard"
        element={
          authenticated
            ? (
                <Dashboard
                  onLogout={
                    handleLogout
                  }
                />
              )
            : (
                <Navigate
                  to="/login"
                  replace
                />
              )
        }
      />


      {/* ============================================= */}
      {/* STORAGE */}
      {/* ============================================= */}

      <Route
        path="/storage/*"
        element={
          authenticated
            ? (
                <Dashboard
                  onLogout={
                    handleLogout
                  }
                />
              )
            : (
                <Navigate
                  to="/login"
                  replace
                />
              )
        }
      />


      {/* ============================================= */}
      {/* PHOTOS */}
      {/* ============================================= */}

      <Route
        path="/photos"
        element={
          authenticated
            ? (
                <Dashboard
                  onLogout={
                    handleLogout
                  }
                />
              )
            : (
                <Navigate
                  to="/login"
                  replace
                />
              )
        }
      />


      {/* ============================================= */}
      {/* SONGS */}
      {/* ============================================= */}

      <Route
        path="/songs"
        element={
          authenticated
            ? (
                <Dashboard
                  onLogout={
                    handleLogout
                  }
                />
              )
            : (
                <Navigate
                  to="/login"
                  replace
                />
              )
        }
      />


      {/* ============================================= */}
      {/* CHAT */}
      {/* ============================================= */}

      <Route
        path="/chat"
        element={
          authenticated
            ? (
                <Dashboard
                  onLogout={
                    handleLogout
                  }
                />
            )
            : (
                <Navigate
                  to="/login"
                  replace
                />
            )
        }
      />


      {/* ============================================= */}
      {/* PROFILE */}
      {/* ============================================= */}

      <Route
        path="/profile"
        element={
          authenticated
            ? (
                <Dashboard
                  onLogout={
                    handleLogout
                  }
                />
              )
            : (
                <Navigate
                  to="/login"
                  replace
                />
              )
        }
      />


      {/* ============================================= */}
      {/* SETTINGS */}
      {/* ============================================= */}

      <Route
        path="/settings"
        element={
          authenticated
            ? (
                <Dashboard
                  onLogout={
                    handleLogout
                  }
                />
              )
            : (
                <Navigate
                  to="/login"
                  replace
                />
              )
        }
      />


      {/* ============================================= */}
      {/* ROOT */}
      {/* ============================================= */}

      <Route
        path="/"
        element={
          <Navigate
            to="/login"
            replace
          />
        }
      />


      {/* ============================================= */}
      {/* UNKNOWN URL */}
      {/* ============================================= */}

      <Route
        path="*"
        element={
          <Navigate
            to="/login"
            replace
          />
        }
      />


    </Routes>

  );

}


// =====================================================
// APP
// =====================================================

function App() {

  return (

    <BrowserRouter>

      <AppRoutes />

    </BrowserRouter>

  );

}


export default App;

